import {
  Box,
  Card,
  Checkbox,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Button as MUIButton,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  NumberField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';


const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();

  return (
    <DashboardContent>
      <PermissionGuard resource="swap-token-route-statistics" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={translate('resource.tokenRouteStatistics')}
          links={[
            { name: translate('resource.transaction'), href: '#' },
            {
              name: translate('resource.tokenRouteStatistics'),
              href: `/${Resources.tokenRouteStatistics}`,
            },
            { name: translate('resource.list') },
          ]}
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            perPage={10}
            exporter={false}
          >
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                // bulkActionButtons={
                //   <PermissionButton resource="swap-token-route-statistics" action="delete">
                //     <BulkDeleteButton />
                //   </PermissionButton>
                // }
                sx={{
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >

                <TextField
                  source="platform"
                  label="module.tokenRouteStatistics.platform"
                  sortable={false}
                />
                <TextField
                  source="fromChain"
                  label="module.tokenRouteStatistics.fromChain"
                  sortable={false}
                />
                <TextField
                  source="toChain"
                  label="module.tokenRouteStatistics.toChain"
                  sortable={false}
                />
                <TextField
                  source="fromSymbol"
                  label="module.tokenRouteStatistics.fromSymbol"
                  sortable={false}
                />
                <TextField
                  source="toSymbol"
                  label="module.tokenRouteStatistics.toSymbol"
                  sortable={false}
                />
                <NumberField
                  source="totalSwapUsd"
                  label="module.tokenRouteStatistics.totalSwapUsd"
                  sortable={false}
                />
                <NumberField
                  source="usageCount"
                  label="module.tokenRouteStatistics.usageCount"
                  sortable={false}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        {/* <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog> */}
      </PermissionGuard>
    </DashboardContent>
  );
};

export default View;
